import { formatInTimeZone, getTimezoneOffset } from "date-fns-tz";

// The business operates in Atlantic Time. Every booking time is displayed and
// transmitted relative to this zone — never the browser's local zone — so a
// travelling client or a misconfigured device still books the correct Halifax slot.
export const HALIFAX_TZ = "America/Halifax";

/** "AST" during standard time, "ADT" during daylight time. */
export function atlanticAbbreviation(iso: string | Date): string {
  const offsetHours = getTimezoneOffset(HALIFAX_TZ, new Date(iso)) / 3_600_000;
  return offsetHours === -3 ? "ADT" : "AST";
}

/** e.g. "1:30 PM ADT" */
export function formatSlotTime(iso: string | Date): string {
  const time = formatInTimeZone(new Date(iso), HALIFAX_TZ, "h:mm a");
  return `${time} ${atlanticAbbreviation(iso)}`;
}

/** e.g. "Tue, 11 Mar 2026" (Canadian English) */
export function formatSlotDate(iso: string | Date): string {
  return formatInTimeZone(new Date(iso), HALIFAX_TZ, "EEE, d MMM yyyy");
}

/** e.g. "Tuesday, 11 March 2026" */
export function formatSlotDateLong(iso: string | Date): string {
  return formatInTimeZone(new Date(iso), HALIFAX_TZ, "EEEE, d MMMM yyyy");
}

/** Convert an ISO instant to the naive Halifax wall-clock string the API expects. */
export function toHalifaxWallClock(iso: string | Date): string {
  return formatInTimeZone(new Date(iso), HALIFAX_TZ, "yyyy-MM-dd HH:mm:ss");
}

/** The yyyy-MM-dd calendar date of an instant, in Halifax. */
export function toHalifaxDateString(iso: string | Date): string {
  return formatInTimeZone(new Date(iso), HALIFAX_TZ, "yyyy-MM-dd");
}
